import { OverlayDrawer } from '@theme/overlay-drawer';

/**
 * @typedef {{ panel?: HTMLElement, items?: HTMLElement[] }} ImageZoomRefs
 */

/**
 * Full-screen product images. Gallery buttons open it on their image with
 * `on:click="#image-zoom/openAt/<index>"`; each image is a `ref="items[]"`.
 * Everything else (focus, Escape, scroll lock) comes from OverlayDrawer.
 */
class ImageZoom extends OverlayDrawer {
  /**
   * @param {string} index Zero-based image index
   * @param {Event} [event]
   */
  openAt(index, event) {
    this.open(event);
    setTimeout(() => {
      const { items } = /** @type {ImageZoomRefs} */ (this.refs);
      items?.[Number(index)]?.scrollIntoView({ block: 'start' });
    }, 30);
  }
}

if (!customElements.get('image-zoom')) {
  customElements.define('image-zoom', ImageZoom);
}
